import { Popover } from 'app/gamma/src/components/popover';
import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'app/gamma/src/types';
import { HeaderTestIds } from '@trello/webdriverio-tests';
import { AtlassianAppSwitcher } from 'app/src/components/AtlassianAppSwitcher';
import { ProductKeys } from '@atlassiansox/product-store-react';
import { closePopovers } from 'app/gamma/src/modules/state/ui/popovers';
import {
  OverlayType,
  setOverlay,
} from 'app/gamma/src/modules/state/ui/overlay';
import { setLocationToWacSoftware } from 'app/gamma/src/util/product-store';

const POPOVER_TOP_OFFSET = 38;

interface StateProps {
  target: () => HTMLElement | null;
}

interface DispatchProps {
  triggerXFlow: (productKey: ProductKeys) => void;
}

interface AtlassianAppSwitcherPopoverProps extends StateProps, DispatchProps {}

export const AtlassianAppSwitcherPopoverUnconnected: FunctionComponent<AtlassianAppSwitcherPopoverProps> = ({
  target,
  triggerXFlow,
}) => (
  <Popover
    name={HeaderTestIds.AtlassianAppSwitcher}
    offsetTop={POPOVER_TOP_OFFSET}
    target={target}
    title="More from Atlassian"
    testId={HeaderTestIds.AtlassianAppSwitcher}
  >
    {() => (
      <AtlassianAppSwitcher
        triggerXFlow={triggerXFlow}
        onDiscoverMoreClicked={setLocationToWacSoftware}
      />
    )}
  </Popover>
);

export const AtlassianAppSwitcherPopover = connect(
  null,
  (dispatch: Dispatch): DispatchProps => ({
    triggerXFlow: (productKey: ProductKeys) => {
      dispatch(closePopovers());
      dispatch(
        setOverlay({ overlayType: OverlayType.ProductStore, productKey }),
      );
    },
  }),
)(AtlassianAppSwitcherPopoverUnconnected);
